import { PAGINATION_LIMIT_DEFAULT } from '../../constants/query-params'

export function getPageFromItemsCountReduxUtil (itemsCount, itemsPerPage = PAGINATION_LIMIT_DEFAULT) {
  return Math.ceil(itemsCount / itemsPerPage) || 1
}

export function getItemsCountFromPageReduxUtil (page, itemsPerPage = PAGINATION_LIMIT_DEFAULT) {
  return page * itemsPerPage
}
